import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Boatclubroadtomumbaicab() {



  const cardData = {


  keyword: "Boat Club Road to Mumbai Cabs",

  headingDescription: "Trustline Travels offers reliable Boat Club Road to Mumbai cab services with comfortable vehicles, experienced chauffeurs, and affordable travel solutions for corporate travel, airport transfers, business meetings, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, we ensure timely pickups, safe travel, and a hassle-free experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, and 24/7 customer support, Trustline Travels is the trusted choice for Boat Club Road to Mumbai taxi services.",

  topPlaces: [
    {
      title: "Peninsula Corporate Park",
      description: "Peninsula Corporate Park in Lower Parel is a premium commercial destination housing multinational companies, financial institutions, and modern corporate offices."
    },
    {
      title: "Vashi Commercial Hub",
      description: "Vashi is a thriving commercial center in Navi Mumbai known for corporate offices, business establishments, retail complexes, and excellent connectivity."
    },
    {
      title: "Wagle Estate",
      description: "Wagle Estate in Thane is a prominent industrial and commercial area featuring corporate offices, manufacturing companies, and technology businesses."
    },
    {
      title: "Reliance Corporate Park",
      description: "Reliance Corporate Park in Ghansoli is a world-class business campus with technology centers, corporate offices, and innovation facilities."
    },
    {
      title: "Goregaon Business District",
      description: "Goregaon Business District is a fast-growing commercial zone with IT parks, corporate offices, exhibition venues, and business centers."
    },
    {
      title: "TTC Industrial Area",
      description: "TTC Industrial Area is one of Navi Mumbai's major industrial corridors, home to logistics companies, engineering firms, and manufacturing industries."
    },
    {
      title: "Siddhivinayak Temple",
      description: "Siddhivinayak Temple is one of Mumbai's most revered Lord Ganesha temples, welcoming thousands of devotees and visitors every day."
    },
    {
      title: "Madh Island",
      description: "Madh Island is a peaceful coastal getaway known for its beaches, resorts, fishing villages, and relaxing weekend atmosphere."
    },
    {
      title: "Taraporewala Aquarium",
      description: "Taraporewala Aquarium is one of India's oldest aquariums, featuring diverse marine life and engaging exhibits for visitors of all ages."
    },
    {
      title: "Jehangir Art Gallery",
      description: "Jehangir Art Gallery is one of Mumbai's most celebrated art venues, showcasing contemporary paintings, sculptures, and cultural exhibitions."
    }
  ],





"services": [
  {
    "name": "Boat Club Road to Mumbai Cab Service",
    "description": "Book Boat Club Road to Mumbai cab service for comfortable and reliable outstation travel with professional drivers, clean AC vehicles, and affordable pricing. Ideal for airport transfers, business trips, family travel, and Mumbai city journeys with Sedan, Ertiga, Innova Crysta, and SUV options."
  },
  {
    "name": "Boat Club Road to Mumbai Taxi",
    "description": "Hire Boat Club Road to Mumbai taxi for safe and convenient travel with experienced chauffeurs, doorstep pickup, and well-maintained vehicles for one-way and round-trip journeys."
  },
  {
    "name": "Boat Club Road to Mumbai Cab Price",
    "description": "Get Boat Club Road to Mumbai cab price with transparent fares for Sedan, Ertiga, Innova Crysta, and premium vehicles. Choose affordable travel options according to your requirement."
  },
  {
    "name": "Boat Club Road to Mumbai Innova Cab",
    "description": "Book Boat Club Road to Mumbai Innova cab for spacious and comfortable family travel with premium seating, luggage space, and experienced drivers."
  },
  {
    "name": "Boat Club Road to Dadar Cab Service",
    "description": "Book Boat Club Road to Dadar cab service for smooth Mumbai city travel with private AC cars, professional drivers, and reliable pickup service."
  },
  {
    "name": "Sangamwadi to Mumbai Cabs",
    "description": "Sangamwadi to Mumbai cabs offer convenient outstation transportation with affordable fares, comfortable vehicles, and experienced chauffeurs."
  },
  {
    "name": "Sangamwadi to Mumbai Airport Cabs",
    "description": "Book Sangamwadi to Mumbai Airport cabs for timely airport pickup and drop with luggage-friendly vehicles and reliable service."
  },
  {
    "name": "Best Cab Service Pune to Mumbai",
    "description": "Choose the best Pune to Mumbai cab service for safe highway travel, professional drivers, affordable pricing, and multiple vehicle choices."
  },
  {
    "name": "Yerwada to Mumbai Cab Service",
    "description": "Book Yerwada to Mumbai cab service for comfortable long-distance travel with AC cars, experienced drivers, and flexible one-way or round-trip options."
  },
  {
    "name": "Cab Service in Yerwada Pune",
    "description": "Get reliable cab service in Yerwada Pune for airport transfers, local travel, corporate trips, and outstation journeys with well-maintained vehicles."
  },
  {
    "name": "Cab Service in Bund Garden Pune",
    "description": "Hire cab service in Bund Garden Pune for local and outstation travel with professional drivers, affordable fares, and comfortable AC vehicles."
  },
  {
    "name": "Bund Garden to Mumbai Cab",
    "description": "Book Bund Garden to Mumbai cab for safe and convenient travel with doorstep pickup, private taxis, and premium vehicle options."
  },
  {
    "name": "Boat Club Road Taxi Service",
    "description": "Boat Club Road taxi service provides reliable transportation solutions for airport drops, corporate travel, family trips, and Mumbai outstation journeys."
  },
  {
    "name": "Cab Service in Boat Club Road Pune",
    "description": "Cab service in Boat Club Road Pune offers trusted taxi booking with professional chauffeurs, clean vehicles, and affordable travel solutions."
  },
  {
    "name": "Cheapest Cab Service in Boat Club Road Pune",
    "description": "Book the cheapest cab service in Boat Club Road Pune with budget-friendly fares, reliable drivers, and comfortable vehicles for local and outstation travel."
  },
  {
    "name": "Boat Club Road to Mumbai One Way Cab",
    "description": "Choose Boat Club Road to Mumbai one way cab for affordable single-side travel without return charges. Perfect for airport, business, and personal journeys."
  },
  {
    "name": "Boat Club Road to Mumbai Car Rental",
    "description": "Hire Boat Club Road to Mumbai car rental service with chauffeur-driven vehicles for comfortable and hassle-free travel."
  },
  {
    "name": "Cheap Boat Club Road to Mumbai Cab",
    "description": "Get affordable Boat Club Road to Mumbai cab service with competitive fares, clean cars, and trusted drivers."
  },
  {
    "name": "Boat Club Road to Mumbai Taxi Fare",
    "description": "Check Boat Club Road to Mumbai taxi fare with transparent pricing for Sedan, Ertiga, Innova Crysta, and SUV cabs."
  },
  {
    "name": "Book Boat Club Road to Mumbai Cab Online",
    "description": "Book Boat Club Road to Mumbai cab online with quick confirmation, easy booking process, and reliable outstation taxi service."
  },
  {
    "name": "Boat Club Road to Mumbai Outstation Cab",
    "description": "Boat Club Road to Mumbai outstation cab service provides safe highway journeys with experienced drivers and comfortable vehicles."
  },
  {
    "name": "Boat Club Road to Mumbai Airport Cab",
    "description": "Book Boat Club Road to Mumbai Airport cab for punctual airport transfers with professional drivers and AC vehicles."
  },
  {
    "name": "24x7 Boat Club Road to Mumbai Taxi Service",
    "description": "24x7 Boat Club Road to Mumbai taxi service available anytime for airport travel, urgent trips, corporate journeys, and family transportation."
  },
  {
    "name": "Best Boat Club Road to Mumbai Cab Service",
    "description": "Choose the best Boat Club Road to Mumbai cab service with reliable vehicles, experienced chauffeurs, transparent fares, and customer-focused travel solutions."
  },
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Book Pune to Mumbai Airport cab service for comfortable airport transfers with timely pickup, professional drivers, and premium AC vehicles."
  },
  {
    "name": "Pune Mumbai Cab",
    "description": "Pune Mumbai cab service provides affordable one-way, round-trip, airport, and corporate travel solutions with Sedan, Ertiga, and Innova Crysta cars."
  }
],

"tableData": [
  ["Boat Club Road to Mumbai Cab Service", "Boat Club Road to Mumbai Taxi"],
  ["Boat Club Road to Mumbai Cab Price", "Boat Club Road to Mumbai Innova Cab"],
  ["Boat Club Road to Dadar Cab Service", "Sangamwadi to Mumbai Cabs"],
  ["Sangamwadi to Mumbai Airport Cabs", "Best Cab Service Pune to Mumbai"],
  ["Yerwada to Mumbai Cab Service", "Cab Service in Yerwada Pune"],
  ["Cab Service in Bund Garden Pune", "Bund Garden to Mumbai Cab"],
  ["Boat Club Road Taxi Service", "Cab Service in Boat Club Road Pune"],
  ["Cheapest Cab Service in Boat Club Road Pune", "Boat Club Road to Mumbai One Way Cab"],
  ["Boat Club Road to Mumbai Car Rental", "Cheap Boat Club Road to Mumbai Cab"],
  ["Boat Club Road to Mumbai Taxi Fare", "Book Boat Club Road to Mumbai Cab Online"],
  ["Boat Club Road to Mumbai Outstation Cab", "Boat Club Road to Mumbai Airport Cab"],
  ["24x7 Boat Club Road to Mumbai Taxi Service", "Best Boat Club Road to Mumbai Cab Service"],
  ["Pune to Mumbai Airport Cab", "Pune Mumbai Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Premium Boat Club Road to Mumbai Cab Service",
    WhyChoosedescription: "Trustline Travels offers reliable cab services from Boat Club Road to Mumbai with comfortable vehicles and professional drivers."
  },
  {
    WhyChooseheading: "Convenient Doorstep Pickup",
    WhyChoosedescription: "Enjoy hassle-free pickup from Boat Club Road, Sangamwadi, Bund Garden, Pune Station, and nearby premium localities."
  },
  {
    WhyChooseheading: "Safe & Professional Chauffeurs",
    WhyChoosedescription: "Our experienced drivers ensure a secure, smooth, and punctual journey via the Pune-Mumbai Expressway."
  },
  {
    WhyChooseheading: "Competitive & Transparent Pricing",
    WhyChoosedescription: "Book your Mumbai cab with confidence through upfront pricing, detailed fare information, and zero hidden charges."
  },
  {
    WhyChooseheading: "Fleet for Every Travel Need",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for individuals, families, and groups."
  },
  {
    WhyChooseheading: "Flexible Travel Booking",
    WhyChoosedescription: "We provide one-way cabs, round trips, airport transfers, and customized outstation travel solutions."
  },
  {
    WhyChooseheading: "Perfect for Business & Airport Transfers",
    WhyChoosedescription: "Ideal for corporate executives, hotel guests, Mumbai Airport transfers, and leisure travelers."
  },
  {
    WhyChooseheading: "Instant Cab Confirmation",
    WhyChoosedescription: "Receive quick fare quotations and immediate booking confirmation with dedicated customer support."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Boat Club Road to Mumbai cab service?",
    answer: "Yes, Trustline Cab offers dependable Boat Club Road to Mumbai cab services for one-way travel, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Boat Club Road to Mumbai?",
    answer: "Yes, we provide affordable one-way cab services with convenient doorstep pickup from Boat Club Road."
  },
  {
    question: "Which vehicles are available for Boat Club Road to Mumbai travel?",
    answer: "You can choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your travel requirements."
  },
  {
    question: "Do you provide pickup from nearby areas of Boat Club Road?",
    answer: "Yes, pickup is available from Boat Club Road, Bund Garden, Sangamwadi, Pune Station, Koregaon Park, and nearby locations."
  },
  {
    question: "Can I book a cab to Mumbai Airport from Boat Club Road?",
    answer: "Yes, we provide direct cab transfers from Boat Club Road to Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in your booking."
  },
  {
    question: "Is Boat Club Road to Mumbai cab service available 24/7?",
    answer: "Yes, Trustline Travels operates round the clock for early morning, daytime, and late-night travel."
  },
  {
    question: "Can I reserve a cab before my travel date?",
    answer: "Yes, advance booking is available and recommended to secure your preferred vehicle and pickup schedule."
  },
  {
    question: "Do you provide cabs for corporate and hotel guests?",
    answer: "Yes, our services are widely used by corporate professionals, hotel guests, business travelers, and families."
  },
  {
    question: "How can I book a Boat Club Road to Mumbai cab with Trustline Travels?",
    answer: "Simply share your pickup address, travel date, destination, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback: "Trustline Travels made my trip from Boat Club Road to Mumbai completely stress-free. The cab arrived on time, the driver was courteous, and the journey was comfortable from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Deshmukh",
    feedback: "We arranged a Mumbai Airport transfer from Boat Club Road through Trustline Travels. The vehicle was spotless, the service was professional, and everything was managed perfectly.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Boat Club Road to Mumbai Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/boat-club-road-to-mumbai-cab.webp",
  "description": "Book Boat Club Road to Mumbai cab service for safe, comfortable, and affordable intercity travel. Trustline Travels offers one-way, round-trip, airport transfers, and private taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6179"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/boat-club-road-to-mumbai-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Boat Club Road to Mumbai Cab | Affordable Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Boat Club Road to Mumbai cab service with Trustline Travels for affordable one-way, round-trip, and airport transfers. Get Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Boat club road to mumbai cab price, boat club road to mumbai innova cab, cab service in pune boat club road, Cheapest cab service in pune boat club road, boat club road to dadar cab service, sangamwadi to Mumbai Cabs, sangamwadi to mumbai airport cab, boat club road to mumbai taxi service, boat club road to mumbai one way cab, boat club road mumbai airport taxi, pune to mumbai cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Boatclubroadtomumbaicab;